import React, { useEffect, useState } from "react";
import Nav from "../master/NavBar";
import Header from "../master/SideBar";
import {
  closeModal,
  ToastMain,
  SweetAlertShow,
  LoadingDiv,
} from "../master/Master";
import { BankList, BankMoneyTransfer } from "../../api/BankService";
import BankLayout from "./BankLayout";

const FundTarnsfer = () => {
  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);

  const handleTransferSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await BankMoneyTransfer(formData);
      if (response?.data?.status) {
        e.target.reset();
        SweetAlertShow("success", "successfully", response?.data?.message);
        // ToastMain.fire({
        //     icon: "success",
        //     title: response?.data?.message || "Transfer Successful",
        // });
        e.target.reset();
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
        // ToastMain.fire({
        //     icon: "info",
        //     title: response?.data?.message || "Something went wrong",
        // });
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
      // ToastMain.fire({
      //     icon: "error",
      //     title: error?.response?.data?.message || "Something went wrong",
      // });
    } finally {
      setLoading(false);
    }
  };

  const getBanks = async () => {
    setLoading(true);
    try {
      const response = await BankList();
      if (response?.data?.status) {
        setBanks(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
        // ToastMain.fire({
        //     icon: "info",
        //     title: response?.data?.message || "Something went wrong",
        // });
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
      // ToastMain.fire({
      //     icon: "error",
      //     title: error?.response?.data?.message || "Something went wrong",
      // });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getBanks();
  }, []);
  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="container-fluid mt-4">
              <div className="row">
                <BankLayout />
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex">
                        <h4 className="text-primary">Fund Transfer</h4>
                      </div>
                      <form onSubmit={handleTransferSubmit}>
                        <div className="modal-body">
                          <div className="row g-3">
                            {/* Transfer Type */}

                            {/* From Bank */}
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select text-capitalize"
                                  name="from_bank"
                                  required
                                >
                                  <option value="">Select From Bank</option>
                                  {banks.map((b, i) => (
                                    <option key={i} value={b.id}>
                                      {b.owner_name} ({b.account_no})
                                    </option>
                                  ))}
                                </select>
                                <label>From Bank</label>
                              </div>
                            </div>

                            {/* To Bank */}

                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select text-capitalize"
                                  name="to_bank"
                                >
                                  <option value="">Select To Bank</option>
                                  {banks.map((b, i) => (
                                    <option key={i} value={b.id}>
                                      {b.owner_name} ({b.account_no})
                                    </option>
                                  ))}
                                </select>
                                <label>To Bank</label>
                              </div>
                            </div>

                            {/* Amount */}
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="number"
                                  name="amount"
                                  className="form-control text-capitalize"
                                  placeholder="Enter Amount"
                                  required
                                  min="0"
                                  step="any"
                                />
                                <label>Amount</label>
                              </div>
                            </div>

                            {/* Date */}
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="date"
                                  name="transfer_date"
                                  className="form-control text-capitalize"
                                  required
                                  defaultValue={
                                    new Date().toISOString().split("T")[0]
                                  }
                                />
                                <label>Date</label>
                              </div>
                            </div>

                            {/* Description */}
                            <div className="col-md-12">
                              <div className="form-floating form-floating-outline">
                                <input
                                  className="form-control text-capitalize"
                                  type="file"
                                  name="image"
                                  placeholder="Upload Img"
                                />
                                <label>Upload Img</label>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-floating form-floating-outline">
                                <textarea
                                  name="description"
                                  className="form-control text-capitalize input-uppercase"
                                  placeholder="Enter remarks or description"
                                  rows="2"
                                ></textarea>
                                <label>Description</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="modal-footer">
                          <button
                            type="submit"
                            className="btn btn-primary px-5 mt-md-2"
                            disabled={loading}
                          >
                            {loading ? (
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            ) : (
                              "Submit"
                            )}
                            {loading ? " Submitting..." : ""}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FundTarnsfer;
